import {useSelector} from 'react-redux';

import FWU_TARGET_TYPES from '../../enums/iot/fwuTargetTypes';
import IOT_DEVICE_TARGET_NAMES from '../../enums/iot/iodDeviceTargetNames';
import {IIotDeviceTargets} from '../../models/iotDevice';
import fwuPackageService from '../../services/fwu/fwuPackageService';
import {makeSelectIotDeviceData} from '../../state/selectors/iotDevice';

interface IProps {
    iotTargets?: IIotDeviceTargets;
}

export interface IFwuInfo {
    fwuTarget?: FWU_TARGET_TYPES;
    isAvailable?: boolean;
    isCheckInProgress?: boolean;
    isLoaded?: boolean;
    isUsbOnly?: boolean;
    availableFirmwares?: any[];
}

interface IReturn {
    [IOT_DEVICE_TARGET_NAMES.DEVICE]?: IFwuInfo;
    [IOT_DEVICE_TARGET_NAMES.DEVICE_ENGINE]?: IFwuInfo;
    [IOT_DEVICE_TARGET_NAMES.HOLDER]?: IFwuInfo;
    [IOT_DEVICE_TARGET_NAMES.HOLDER_ENGINE]?: IFwuInfo;
    isInfoLoadedForAllTargets?: boolean;
    isInfoLoadedSuccessfullyForAllTargets?: boolean;
    isAnyFwuAvailable?: boolean;
}

const useFWUInfoLoaded = (props: IProps): IReturn => {
    const {iotTargets} = props;
    const iotDevice = useSelector(makeSelectIotDeviceData());
    const result = fwuPackageService.getFwuLoadedInfo({iotTargets, iotDevice});

    return result;
};

export default useFWUInfoLoaded;
